import { takeLatest, put, call } from 'redux-saga/effects';

import { history } from '@commons';

import {
  createPatrimonioAlertaManutencaoCadastro,
  updatePatrimonioAlertaManutencaoCadastro,
} from '../service';
import {
  CONFIG_SESSION,
  CREATE_PATRIMONIO_ALERTA_MANUTENCAO_CADASTRO,
  CREATE_PATRIMONIO_ALERTA_MANUTENCAO_CADASTRO_PENDING,
  CREATE_PATRIMONIO_ALERTA_MANUTENCAO_CADASTRO_SUCCESS,
  CREATE_PATRIMONIO_ALERTA_MANUTENCAO_CADASTRO_FAILURE,
} from '@handler';
import { storage } from '@commons/storage';
import { AlertSuccess, AlertError, AlertWarning } from '@components/common/AlertToast';
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';


function* sagaCreatePatrimonioAlertaManutencaoCadastro(action) {
  yield put({ type: CREATE_PATRIMONIO_ALERTA_MANUTENCAO_CADASTRO_PENDING })

  try {
    var idAlertaManutencao;
    if (action.data.id === undefined || action.data.id === null) {
      const resp = yield call(createPatrimonioAlertaManutencaoCadastro, action.data);
      trackingEventCX('action', MODULE_ACTIONS_ENUM.PATRIMONIO_MANUTENCAO_ALERTA_CRIAR);
      idAlertaManutencao = resp.data.id;
    } else {
      idAlertaManutencao = action.data.id;
      yield call(updatePatrimonioAlertaManutencaoCadastro,
        {
          ...action.data,
          id: action.data.id
        }
      );
      trackingEventCX('action', MODULE_ACTIONS_ENUM.PATRIMONIO_MANUTENCAO_ALERTA_EDITAR);
    }

    yield put({ type: CREATE_PATRIMONIO_ALERTA_MANUTENCAO_CADASTRO_SUCCESS, registro: action.data });

    if (!action.isCadastroRapido) {
      history.push('/patrimonio/manutencao/alerta');
    }

    AlertSuccess('Registro salvo com sucesso!');

    // const novoRegistro = yield call(findPatrimonioAlertaManutencaoCadastro, idAlertaManutencao);
    // if (novoRegistro.possuiPendenciaEstoque) {
    //   AlertWarning('Estoque não processado por falta de insumos. Verifique a manutenção...');
    // }
  } catch (error) {
    yield put({ type: CREATE_PATRIMONIO_ALERTA_MANUTENCAO_CADASTRO_FAILURE, registro: action.data });

    AlertError('Falha ao salvar o registro! Tente novamente...');
  }
}

export default function* watchCreatePatrimonioAlertaManutencaoCadastro() {
  yield takeLatest(CREATE_PATRIMONIO_ALERTA_MANUTENCAO_CADASTRO, sagaCreatePatrimonioAlertaManutencaoCadastro)
}
